import { Button, ButtonProps, Dropdown, DropdownProps, Icon, IconProps, Portal } from 'bold-ui'
import { ButtonKind, ButtonSize, ButtonSkin } from 'bold-ui/lib/components/Button/Button/ButtonSkins'
import { composeHandlers } from 'bold-ui/lib/util/react'
import { noop } from 'lodash'
import { BaseSyntheticEvent, useState } from 'react'

export interface DropdownButtonProps extends ButtonProps {
  text?: string
  icon?: IconProps['icon']
  iconColor?: string
  children: DropdownProps['children']
  stopPropagationOnAction?: boolean
  isInsideModal?: boolean
  size?: ButtonSize
  skin?: ButtonSkin
  kind?: ButtonKind
  matchButtonWidth: boolean
  dataTestId?: string
}

export function DropdownButton(props: Readonly<DropdownButtonProps>) {
  const {
    text,
    icon,
    iconColor,
    children,
    isInsideModal = false,
    stopPropagationOnAction = false,
    size = 'small',
    skin = 'ghost',
    kind = 'normal',
    matchButtonWidth = false,
    onClick = noop,
    onKeyDown = noop,
    dataTestId = 'Button.Dropdown',
    ...rest
  } = props

  const [buttonRef, setButtonRef] = useState<HTMLButtonElement | null>(null)

  const [open, setOpen] = useState(false)

  const handlePropagation = (e: BaseSyntheticEvent) => stopPropagationOnAction && e.stopPropagation()

  const handleClick = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    buttonRef?.focus()
  }
  const dropdown = (
    <Dropdown
      style={matchButtonWidth && buttonRef?.offsetWidth ? { width: buttonRef.offsetWidth } : undefined}
      anchorRef={buttonRef}
      open={open}
      onClose={handleClose}
      onClick={handlePropagation}
      onKeyDown={handlePropagation}
    >
      {children}
    </Dropdown>
  )

  return (
    <>
      <Button
        innerRef={setButtonRef}
        size={size}
        skin={skin}
        kind={kind}
        onClick={composeHandlers(handlePropagation, handleClick, onClick)}
        onKeyDown={composeHandlers(handlePropagation, onKeyDown)}
        data-testid={dataTestId}
        {...rest}
      >
        {text}
        <Icon icon={icon} color={iconColor} />
      </Button>
      {isInsideModal ? dropdown : <Portal>{dropdown}</Portal>}
    </>
  )
}

DropdownButton.defaultProps = {
  icon: 'dots',
} as Partial<DropdownButtonProps>
